export class OrderAdDetailUpdate {
	id?: string;
	packageId?: string;
	placementId?: string;
	issueDate?: string;
	materialId?: string;
	columns?: number;
	depth?: number;
	moduleCode?: string;
	placementRequest?: string;
	confirmationNumber?: string;
	requestStatus: "confirmed" | undefined;
	materialDeadline?: string;
}
